import React, { useEffect, useMemo, useState } from "react";
import "../solutions/Solutions.css";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const TRADE_SHOW_CONFIG = {
  slug: "ai-infra-summit-2026",

  hero: {
    backgroundImage:
      "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAI%20Infra%20Summit.jpeg?alt=media&token=fb475070-76cd-494f-9486-7d7c3cd87011",

    logo:
      "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fai%20infra%20logo%202.png?alt=media&token=c2876eaa-07fa-4eef-b323-2bceb036271e",

    heading: "OPTICAL EXCELLENCE FOR SMARTER AI INFRASTRUCTURE",

    eventLine: "Join us at AI Infra Summit",

    description:
      "Visit booth #321 to see the latest and greatest fiber connectivity solutions for smarter AI infrastructure.",

    buttonLabel: "Meet at AI Infra Summit",

    buttonLink:
      "mailto:brand@gofoton.com?subject=I%E2%80%99d%20like%20to%20meet%20at%20AI%20Infra%20Summit",

    boothLabel: "Booth 321",

    boothLink: "https://www.ai-infra-summit.com/",
  },

  overview: {
    badge: {
      heading: "AI Infra Summit Exhibit 321",
      dates: "September 15-17, 2026",
      venue: "Santa Clara Convention Center",
      location: "Santa Clara, CA",
      link: "https://www.ai-infra-summit.com/",
    },

    description: (
      <>
        <p>
          We’d love to see you at{" "}
          <a
            href="https://www.ai-infra-summit.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            AI Infra Summit
          </a>
          ! Please join us in booth #321 to see the latest and greatest fiber
          connectivity solutions for smarter AI infrastructure.
        </p>

        <p>
          See the new{" "}
          <a
            href="/peacoc-any-port-panel"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>PEACOC Any Port Panel (APP)</strong>
          </a>
          , designed for high-density AI and data center environments requiring
          scalable Base-16 architectures. And talk with us about our{" "}
          <a
            href="/services"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>turnkey services</strong>
          </a>{" "}
          for data center builds.
        </p>

        <p>
          You’ll get a first-hand look at our innovations that ensure signal
          integrity, minimize loss, and maintain up-time across increasingly
          complex AI infrastructures. Our aim is to imagine and build
          technologies that are (1) simple to install and turn up, (2) scalable
          for rapid growth, (3) support high data rate transmissions, (4)
          maximize density in critical real estate, and are (5) tailored for
          dense mesh topologies needed for AI growth.
        </p>
      </>
    ),
  },

  specialEvents: {
    heading: "Don’t miss these special opportunities at AI Infra Summit",

    cards: [
      {
        title: "Register to win this amazing drone",

        subtitle:
          "Combining power, intelligence, and ease of use into one advanced aerial device.",

        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAerudon%20Air%2B%20(1).png?alt=media&token=04dde073-ecf2-4dfc-93b8-be8288bede6e",

        description:
          "The Aerudon AIR+ GPS Drone is built for creators, adventurers, and beginners who want powerful performance with intelligent flight control. Featuring an 8K camera, GPS auto-return, brushless motors, and 5G real-time transmission, the Aerudon Drone delivers smooth, stable, and cinematic footage from the sky.",

        details: ["Register at Booth 321"],

        buttonLabel: null,
        calendarLink: null,

        secondaryButtonLabel: null,
        secondaryButtonLink: null,
      },

      {
        title:
          "Brian Berdan presents, “Infrastructure That Scales at AI Speed: Meet the new Go!Foton PEACOC APP”",

        subtitle: "",

        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FBrian%20Berdan%20(1)%20copy.jpg?alt=media&token=448ea671-5875-4284-85aa-dc71d5c5f4da",

        description:
          "The PEACOC® Any Port Panel (APP) becomes the backbone for rapid GPU-cluster expansion and Base-16 architectures. This product spotlight shows how modular fiber design removes friction from every stage of AI growth.",

        details: [
          "Expo Theater 2",
          "Tuesday, September 15",
          "12:15 PM - 12:30 PM",
        ],

        buttonLabel: "Add to calendar",

        calendarLink:
          "https://calendar.google.com/calendar/render?action=TEMPLATE&text=Infrastructure%20That%20Scales%20at%20AI%20Speed%3A%20Meet%20the%20new%20Go!Foton%20PEACOC%20APP&dates=20260915T191500Z/20260915T193000Z&details=Brian%20Berdan%20presents%20Infrastructure%20That%20Scales%20at%20AI%20Speed%3A%20Meet%20the%20new%20Go!Foton%20PEACOC%20APP.&location=Expo%20Theater%202%2C%20Santa%20Clara%20Convention%20Center",

        secondaryButtonLabel: "View APP",

        secondaryButtonLink: "/peacoc-any-port-panel",
      },
    ],
  },

  featuredProducts: {
    heading: "Get a hands-on look at our AI-ready fiber optic connectivity",

    items: [
      {
        name: "EVA",

        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2F4RU_Stack_Fully-Loaded_open-door_Isometric.webp?alt=media&token=cfe6a686-afc2-4285-bd5a-6e05b1bda297",

        link: "/peacoc-enhanced-view-and-access-eva-high-density-patch-panel",
      },

      {
        name: "APP",

        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FPEACOC%20APP%20Panel_%20Isoetric%20View.png?alt=media&token=bac369ea-5caf-4abb-8f99-66c156882543",

        link: "/peacoc-any-port-panel",
      },

      {
        name: "Cable Assemblies",

        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2F%20MPO%2C%20SC%20Simplex%2C%20LC%20Duplex%20Connectors%20web%20(1)%20copy.jpg?alt=media&token=8a638a1f-9568-4659-817a-50f138d30058",

        link: "/family/fiber-cable-assemblies",
      },

      {
        name: "Services",

        image: "/images/services/ServicesImage.png",

        link: "/services",
      },

      {
        name: "PEACOC 360",

        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FP360_IsometricView_NoDoor_2.jpg?alt=media&token=bf4587da-0cbc-4f14-bba3-8ecf99ba2bc2",

        link: "/peacoc-360-spooling-patch-panel",
      },

      {
        name: "Fiber Slack Panel",

        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FFiber%20Slack%20Panel%20-%20Open%20-%20L.png?alt=media&token=d0d904aa-d1b2-4a6a-889e-023fdeba3f38",

        link: "/fiber-slack-panel",
      },
    ],
  },

  subscribe: {
    enabled: true,

    heading:
      "Can’t make AI Infra Summit 2026? Let’s stay in touch.",

    buttonLabel: "Subscribe to Go!Foton news",

    buttonLink: "/subscribe",
  },

  /*
    Not requested for this tradeshow.

    Keeping these fields in the data structure means
    you can enable them for another tradeshow later
    without rebuilding the template.
  */

  otherShows: {
    enabled: false,
    heading: "Other upcoming shows",
    shows: [],
  },

  mobileUnit: {
    enabled: false,
    heading: "Need us to come to you?",
    buttonLabel: "Request the Go!Foton mobile demo unit",

    buttonLink:
      "mailto:brand@gofoton.com?subject=I%E2%80%99d%20like%20to%20request%20a%20Go!Foton%20mobile%20demo",
  },
};

function AIInfraSummit() {
  const [productIndex, setProductIndex] = useState(0);
  const [productsPerView, setProductsPerView] = useState(3);

  useEffect(() => {
    const updateLayout = () => {
      if (window.innerWidth <= 768) {
        setProductsPerView(1);
      } else if (window.innerWidth <= 1100) {
        setProductsPerView(2);
      } else {
        setProductsPerView(3);
      }
    };

    updateLayout();

    window.addEventListener("resize", updateLayout);

    return () => {
      window.removeEventListener("resize", updateLayout);
    };
  }, []);

  const maximumProductIndex = useMemo(() => {
    return Math.max(
      TRADE_SHOW_CONFIG.featuredProducts.items.length - productsPerView,
      0
    );
  }, [productsPerView]);

  useEffect(() => {
    if (productIndex > maximumProductIndex) {
      setProductIndex(maximumProductIndex);
    }
  }, [productIndex, maximumProductIndex]);

  const goToPreviousProduct = () => {
    setProductIndex((current) => Math.max(current - 1, 0));
  };

  const goToNextProduct = () => {
    setProductIndex((current) =>
      Math.min(current + 1, maximumProductIndex)
    );
  };

  return (
    <div className="contact-page ise-page">

      {/* MARQUEE */}

      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
            src=""
            poster={TRADE_SHOW_CONFIG.hero.backgroundImage}
            autoPlay
            loop
            muted
            playsInline
          />

          <div className="single-overlay-content">
            <h1>{TRADE_SHOW_CONFIG.hero.heading}</h1>

            {TRADE_SHOW_CONFIG.hero.eventLine && (
              <h2>{TRADE_SHOW_CONFIG.hero.eventLine}</h2>
            )}

            <p>{TRADE_SHOW_CONFIG.hero.description}</p>

            <a
              href={TRADE_SHOW_CONFIG.hero.buttonLink}
              className="cta-button"
            >
              {TRADE_SHOW_CONFIG.hero.buttonLabel}
            </a>
          </div>

          <div className="ise-expo-logo-wrapper">
            <img
              className="ise-expo-logo"
              src={TRADE_SHOW_CONFIG.hero.logo}
              alt="AI Infra Summit"
            />

            {TRADE_SHOW_CONFIG.hero.boothLabel && (
              <div className="ise-expo-booth">
                {TRADE_SHOW_CONFIG.hero.boothLabel}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* CURVED DIVIDER */}

      <svg
        className="section-divider"
        viewBox="0 0 1440 150"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id="aiInfraWhiteSplit"
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop
              offset="50%"
              stopColor="white"
              stopOpacity="1"
            />
          </linearGradient>
        </defs>

        <path
          d="
            M0,150
            H1440
            V0
            Q720,75 0,0
            Z
          "
          fill="url(#aiInfraWhiteSplit)"
        />
      </svg>

      {/* OVERVIEW */}

      <section className="trade-show-overview">

        <aside className="trade-show-event-badge">

          <a
            href={TRADE_SHOW_CONFIG.overview.badge.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={TRADE_SHOW_CONFIG.hero.logo}
              alt="AI Infra Summit"
            />
          </a>

          <strong>
            {TRADE_SHOW_CONFIG.overview.badge.heading}
          </strong>

          <span>
            {TRADE_SHOW_CONFIG.overview.badge.dates}
          </span>

          {TRADE_SHOW_CONFIG.overview.badge.venue && (
            <span>
              {TRADE_SHOW_CONFIG.overview.badge.venue}
            </span>
          )}

          <span>
            {TRADE_SHOW_CONFIG.overview.badge.location}
          </span>

        </aside>

        <div className="trade-show-overview-text">
          {TRADE_SHOW_CONFIG.overview.description}
        </div>

      </section>

      {/* SPECIAL OPPORTUNITIES */}

      <section className="trade-show-section">

        <h2 className="trade-show-section-title">
          {TRADE_SHOW_CONFIG.specialEvents.heading}
        </h2>

        <div className="trade-show-special-events">

          {TRADE_SHOW_CONFIG.specialEvents.cards.map((event) => (
            <article
              className="trade-show-special-card"
              key={event.title}
            >

              <img
                src={event.image}
                alt={event.title}
              />

              <div className="trade-show-special-card-content">

                <h3>{event.title}</h3>

                {event.subtitle && (
                  <h4>{event.subtitle}</h4>
                )}

                {event.description && (
                  <p className="trade-show-special-description">
                    {event.description}
                  </p>
                )}

                {event.details?.length > 0 && (
                  <div className="trade-show-special-details">

                    {event.details.map((detail) => (
                      <span key={detail}>
                        {detail}
                      </span>
                    ))}

                  </div>
                )}

                {(event.buttonLabel ||
                  event.secondaryButtonLabel) && (
                  <div className="trade-show-card-buttons">

                    {event.buttonLabel &&
                      event.calendarLink && (
                        <a
                          className="trade-show-small-button"
                          href={event.calendarLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {event.buttonLabel}
                        </a>
                      )}

                    {event.secondaryButtonLabel &&
                      event.secondaryButtonLink && (
                        <a
                          className="trade-show-small-button secondary"
                          href={event.secondaryButtonLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {event.secondaryButtonLabel}
                        </a>
                      )}

                  </div>
                )}

              </div>
            </article>
          ))}

        </div>
      </section>

      {/* FEATURED PRODUCTS */}

      <section className="trade-show-section trade-show-products-section">

        <h2 className="trade-show-section-title">
          {TRADE_SHOW_CONFIG.featuredProducts.heading}
        </h2>

        <div className="trade-show-product-slider">

          <button
            type="button"
            className="trade-show-slider-arrow"
            onClick={goToPreviousProduct}
            disabled={productIndex === 0}
            aria-label="Previous products"
          >
            <IoChevronBack />
          </button>

          <div className="trade-show-product-viewport">

            <div
              className="trade-show-product-track"
              style={{
                transform: `translateX(-${
                  productIndex * (100 / productsPerView)
                }%)`,

                "--trade-products-per-view":
                  productsPerView,
              }}
            >

              {TRADE_SHOW_CONFIG.featuredProducts.items.map(
                (product) => (
                  <div
                    className="trade-show-product-slide"
                    key={product.name}
                  >

                    <a
                      className="trade-show-product-card"
                      href={product.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >

                      <img
                        src={product.image}
                        alt={product.name}
                      />

                      <div className="trade-show-product-name">
                        {product.name}
                      </div>

                      <span className="cta-button">
                        View
                      </span>

                    </a>

                  </div>
                )
              )}

            </div>
          </div>

          <button
            type="button"
            className="trade-show-slider-arrow"
            onClick={goToNextProduct}
            disabled={
              productIndex === maximumProductIndex
            }
            aria-label="Next products"
          >
            <IoChevronForward />
          </button>

        </div>
      </section>

      {/* SUBSCRIBE */}

      {TRADE_SHOW_CONFIG.subscribe.enabled && (
        <section className="trade-show-subscribe">

          <h2>
            {TRADE_SHOW_CONFIG.subscribe.heading}
          </h2>

          <a
            className="cta-button"
            href={
              TRADE_SHOW_CONFIG.subscribe.buttonLink
            }
          >
            {
              TRADE_SHOW_CONFIG.subscribe
                .buttonLabel
            }
          </a>

        </section>
      )}

      {/* OPTIONAL OTHER SHOWS */}

      {TRADE_SHOW_CONFIG.otherShows.enabled && (
        <section className="trade-show-section">

          <h2 className="trade-show-section-title">
            {TRADE_SHOW_CONFIG.otherShows.heading}
          </h2>

          <div className="trade-show-other-grid">

            {TRADE_SHOW_CONFIG.otherShows.shows.map(
              (show) => (
                <article
                  className="trade-show-other-card"
                  key={show.name}
                >

                  <h3>{show.name}</h3>

                  <p>{show.location}</p>

                  <p>{show.dates}</p>

                  <a
                    href={show.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cta-button"
                  >
                    View Event
                  </a>

                </article>
              )
            )}

          </div>
        </section>
      )}

      {/* OPTIONAL MOBILE DEMO */}

      {TRADE_SHOW_CONFIG.mobileUnit.enabled && (
        <section className="trade-show-mobile-unit">

          <h2>
            {TRADE_SHOW_CONFIG.mobileUnit.heading}
          </h2>

          <a
            className="cta-button"
            href={
              TRADE_SHOW_CONFIG.mobileUnit.buttonLink
            }
          >
            {
              TRADE_SHOW_CONFIG.mobileUnit
                .buttonLabel
            }
          </a>

        </section>
      )}

    </div>
  );
}

export default AIInfraSummit;